<template>
    <div class="declaring-block-main-aedecp optiscroll stepFour">
        <div class="declaring-block-in-aedecp">
            <div class="common-title-main-aehp common-title-left-aehp">
                <h2>Renseignements relatifs au sinistre</h2>
            </div>
            <div class="declaring-form-main-aedecp">
                <div class="default-form-field1-aedecp">
                    <div class="default-form-field1-in-aedecp">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                            <div class="default-form-field1-tit-aedecp">Date d’apparition des désordres</div>
                            <div class="defa-form-field-Tbox-aedecp defa-form-Dtpicker-aedecp">
                                <input :value="formatDate(renseignements_sinister.date)" placeholder="" type="text"
                                    @change="(e) => remove(e.target)" @blur="(e) => onDateBlur(e, 'date')"
                                    class="cal-size datepicker_hp3">
                            </div>
                        </div>
                    </div>
                </div>
                <template v-if="showDemeure">
                    <div class="default-form-field1-aedecp">
                        <div class="default-form-field1-in-aedecp">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                <div class="default-form-field1-tit-aedecp">Avez-vous adressé une mise en demeure au
                                    constructeur ?</div>
                                <div class="defa-option-list-aedecp">
                                    <div class="defa-option1-aedecp">
                                        <div class="custom-control custom-radio">
                                            <input id="default_option7"
                                                v-model="renseignements_sinister.perfect_achievement" :value="true"
                                                class="custom-control-input" name="completion-option1" type="radio">
                                            <label class="custom-control-label" for="default_option7">Oui</label>
                                        </div>
                                    </div>
                                    <div class="defa-option1-aedecp">
                                        <div class="custom-control custom-radio">
                                            <input id="default_option8"
                                                v-model="renseignements_sinister.perfect_achievement" :value="false"
                                                class="custom-control-input" name="completion-option1" type="radio">
                                            <label class="custom-control-label" for="default_option8">Non</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="default-form-field1-aedecp">
                        <div class="default-form-field1-in-aedecp">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                <div class="default-form-file-upload-tit-aedecp">Si oui, joindre une copie de la mise en
                                    demeure adressée au constructeur
                                </div>
                                <DragAndDrop v-on:updateImages="updateImages" />
                            </div>
                        </div>
                    </div>
                </template>
                <div v-if="this.new" class="default-form-field1-aedecp">
                    <div class="default-form-field1-in-aedecp">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                            <div class="default-form-field1-tit-aedecp">Garanties visées</div>
                            <div class="defa-option-list-aedecp">
                                <div class="defa-option1-aedecp">
                                    <div class="custom-control custom-checkbox">
                                        <input id="covered_guarantees_option1" class="custom-control-input"
                                            name="completion-option1" type="checkbox" value="DO"
                                            v-on:change="addGarantees($event)">
                                        <label class="custom-control-label" for="covered_guarantees_option1">DO</label>
                                    </div>
                                </div>
                                <div class="defa-option1-aedecp">
                                    <div class="custom-control custom-checkbox">
                                        <input id="covered_guarantees_option2" class="custom-control-input"
                                            name="completion-option1" type="checkbox" value="RCD"
                                            v-on:change="addGarantees($event)">
                                        <label class="custom-control-label" for="covered_guarantees_option2">RCD</label>
                                    </div>
                                </div>
                                <div class="defa-option1-aedecp">
                                    <div class="custom-control custom-checkbox">
                                        <input id="covered_guarantees_option3" class="custom-control-input"
                                            name="completion-option1" type="checkbox" value="RCP"
                                            v-on:change="addGarantees($event)">
                                        <label class="custom-control-label" for="covered_guarantees_option3">RCP</label>
                                    </div>
                                </div>
                                <div class="defa-option1-aedecp">
                                    <div class="custom-control custom-checkbox">
                                        <input id="covered_guarantees_option4" class="custom-control-input"
                                            name="completion-option1" type="checkbox" value="TRC"
                                            v-on:change="addGarantees($event)">
                                        <label class="custom-control-label" for="covered_guarantees_option4">TRC</label>
                                    </div>
                                </div>
                                <div class="defa-option1-aedecp">
                                    <div class="custom-control custom-checkbox">
                                        <input id="covered_guarantees_option5" class="custom-control-input"
                                            name="completion-option1" type="checkbox" value="CNR"
                                            v-on:change="addGarantees($event)">
                                        <label class="custom-control-label" for="covered_guarantees_option5">CNR</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="default-form-field1-aedecp">
                    <div class="default-form-field1-in-aedecp">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                            <div class="default-form-field1-tit-aedecp">Nature des désordres
                                <div><span style="padding-left: 0;">Renseignez l’ensemble des sinistres dans les
                                        rubriques correspondantes :</span></div>
                            </div>
                            <div class="Ndisorders-block-main-aedecp">
                                <div id="Fissures" class="accordion">
                                    <div class="card Ndisorders-box1-main-aedecp">
                                        <div id="Ndisorders_heading1" class="card-header">
                                            <a aria-controls="Fissures_collapse1" aria-expanded="false"
                                                :class="['collapse', haveCrackFilled ? 'checked' : '']"
                                                data-target="#Fissures_collapse1" data-toggle="collapse" href="#">
                                                Fissures
                                            </a>
                                        </div>
                                        <div id="Fissures_collapse1" aria-labelledby="Fissures_heading1"
                                            class="collapse" data-parent="#Fissures">
                                            <div v-for="(crack, key) in renseignements_sinister.cracks" :key="key"
                                                class="card-body Ndisorders-info-box-aedecp">
                                                <div class="title">
                                                    <div
                                                        class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp">
                                                        Fissure {{ key + 1 }}
                                                    </div>
                                                    <div class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp custom-add"
                                                        @click="deleteCrack(key)">
                                                        <p class="btn-custom">X</p>
                                                    </div>
                                                </div>
                                                <div class="Ndisord-info-box-in-aedecp">
                                                    <div class="default-form-field1-aedecp">
                                                        <div class="default-form-field1-in-aedecp">
                                                            <div
                                                                class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                                                <div
                                                                    class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp">
                                                                    Localisation (intérieur/extérieur, pièce de la
                                                                    maison, mur/plafond…)
                                                                </div>
                                                                <div class="defa-form-field-Tbox-aedecp">
                                                                    <input v-model="crack.location" placeholder=""
                                                                        type="text" maxlength="200">
                                                                    <div class="character-count" :style="{
                                                                        'text-align': 'right',
                                                                        'font-size': '12px',
                                                                        'color': crack.location?.length >= 200 ? '#dc3545' : '#6c757d',
                                                                        'margin-top': '5px'
                                                                    }">
                                                                        <template
                                                                            v-if="crack.location?.length >= 200">maximum
                                                                            200 caractères</template>
                                                                        <template v-else>
                                                                            {{ crack.location?.length ?? 0 }} /
                                                                            200
                                                                            caractères restants
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="default-form-field1-aedecp">
                                                        <div class="default-form-field1-in-aedecp">
                                                            <div
                                                                class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                                                <div
                                                                    class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp">
                                                                    Écart entre les 2 bords de la fissure (Facultatif)
                                                                </div>
                                                                <div class="defa-option-list-aedecp">
                                                                    <div class="defa-option1-aedecp">
                                                                        <div class="custom-control custom-radio">
                                                                            <input :id="'gap_inferior' + key"
                                                                                v-model="crack.gap" value="inferior"
                                                                                class="custom-control-input"
                                                                                :name="'origin-option1' + key"
                                                                                type="radio">
                                                                            <label class="custom-control-label"
                                                                                :for="'gap_inferior' + key">Inférieur
                                                                                à 2mm</label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="defa-option1-aedecp">
                                                                        <div class="custom-control custom-radio">
                                                                            <input :id="'gap_superior' + key"
                                                                                v-model="crack.gap" value="superior"
                                                                                class="custom-control-input"
                                                                                :name="'origin-option1' + key"
                                                                                type="radio">
                                                                            <label class="custom-control-label"
                                                                                :for="'gap_superior' + key">Supérieur
                                                                                à 2mm</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="default-form-field1-aedecp">
                                                        <div class="default-form-field1-in-aedecp">
                                                            <div
                                                                class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                                                <div
                                                                    class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp">
                                                                    Engendre-t-elle (Facultatif) :
                                                                </div>
                                                                <div class="default-sub-form-row1-aedecp">
                                                                    <div
                                                                        class="defa-Ffield1-col1-aedecp defa-Ffield-Wauto-aedecp">
                                                                        <div class="default-form-field1-Stit-aedecp">des
                                                                            infiltrations</div>
                                                                        <div class="defa-option-list-aedecp">
                                                                            <div class="defa-option1-aedecp">
                                                                                <div
                                                                                    class="custom-control custom-radio">
                                                                                    <input :id="'default_option9' + key"
                                                                                        v-model="crack.engenders_infiltration"
                                                                                        :value="true"
                                                                                        class="custom-control-input"
                                                                                        :name="'generate-option1' + key"
                                                                                        type="radio">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'default_option9' + key">Oui</label>
                                                                                </div>
                                                                            </div>
                                                                            <div class="defa-option1-aedecp">
                                                                                <div
                                                                                    class="custom-control custom-radio">
                                                                                    <input
                                                                                        :id="'default_option10' + key"
                                                                                        v-model="crack.engenders_infiltration"
                                                                                        :value="false"
                                                                                        class="custom-control-input"
                                                                                        :name="'generate-option1' + key"
                                                                                        type="radio">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'default_option10' + key">Non</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="defa-Ffield1-col1-aedecp defa-Ffield-Wauto-aedecp">
                                                                        <div class="default-form-field1-Stit-aedecp">un
                                                                            risque de chute de matériaux</div>
                                                                        <div class="defa-option-list-aedecp">
                                                                            <div class="defa-option1-aedecp">
                                                                                <div
                                                                                    class="custom-control custom-radio">
                                                                                    <input
                                                                                        :id="'default_option11' + key"
                                                                                        v-model="crack.material_fall_risk"
                                                                                        :value="true"
                                                                                        class="custom-control-input"
                                                                                        :name="'generate-option2' + key"
                                                                                        type="radio">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'default_option11' + key">Oui</label>
                                                                                </div>
                                                                            </div>
                                                                            <div class="defa-option1-aedecp">
                                                                                <div
                                                                                    class="custom-control custom-radio">
                                                                                    <input
                                                                                        :id="'default_option12' + key"
                                                                                        v-model="crack.material_fall_risk"
                                                                                        :value="false"
                                                                                        class="custom-control-input"
                                                                                        :name="'generate-option2' + key"
                                                                                        type="radio">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'default_option12' + key">Non</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="default-form-field1-aedecp">
                                                        <div class="default-form-field1-in-aedecp">
                                                            <div
                                                                class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                                                <div class="default-form-file-upload-tit-aedecp">Si vous
                                                                    disposez de photos de ce désordre, veuillez les
                                                                    joindre ci-dessous (2 photos max par désordre).
                                                                </div>
                                                                <DragAndDrop
                                                                    v-on:updateImages="e => crack.images = e.images"
                                                                    :max="2" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="contentAdd">
                                                <div class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp custom-add"
                                                    @click="addCrack">
                                                    <p class="btn-custom">+</p> Ajouter une fissure
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="Infiltrations" class="accordion">
                                    <div class="card Ndisorders-box1-main-aedecp">
                                        <div id="Infiltrations_heading2" class="card-header">
                                            <a aria-controls="Infiltrations_collapse2" aria-expanded="false"
                                                :class="['collapse', haveInfiltrationFilled ? 'checked' : '']"
                                                data-target="#Infiltrations_collapse2" data-toggle="collapse" href="#">
                                                Infiltrations
                                            </a>
                                        </div>
                                        <div id="Infiltrations_collapse2" aria-labelledby="Infiltrations_heading2"
                                            class="collapse" data-parent="#Infiltrations">
                                            <div v-for="(infiltration, key) in renseignements_sinister.infiltrations"
                                                :key="key" class="card-body Ndisorders-info-box-aedecp">
                                                <div class="title">
                                                    <div
                                                        class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp">
                                                        Infiltration {{ key + 1 }}
                                                    </div>
                                                    <div class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp custom-add"
                                                        @click="deleteInfiltration(key)">
                                                        <p class="btn-custom">X</p>
                                                    </div>
                                                </div>
                                                <div class="Ndisord-info-box-in-aedecp">
                                                    <div class="default-form-field1-aedecp">
                                                        <div class="default-form-field1-in-aedecp">
                                                            <div
                                                                class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                                                <div
                                                                    class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp">
                                                                    Localisation (intérieur/extérieur, pièce de la
                                                                    maison, mur/plafond…)
                                                                </div>
                                                                <div class="defa-form-field-Tbox-aedecp">
                                                                    <input v-model="infiltration.location"
                                                                        placeholder="" type="text" maxlength="200">
                                                                    <div class="character-count" :style="{
                                                                        'text-align': 'right',
                                                                        'font-size': '12px',
                                                                        'color': infiltration.location?.length >= 200 ? '#dc3545' : '#6c757d',
                                                                        'margin-top': '5px'
                                                                    }">
                                                                        <template
                                                                            v-if="infiltration.location?.length >= 200">maximum
                                                                            200 caractères</template>
                                                                        <template v-else>
                                                                            {{ infiltration.location?.length ?? 0 }} /
                                                                            200
                                                                            caractères restants
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="default-form-field1-aedecp">
                                                        <div class="default-form-field1-in-aedecp">
                                                            <div
                                                                class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                                                <div
                                                                    class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp">
                                                                    Importance (Facultatif)
                                                                </div>
                                                                <div class="defa-option-list-aedecp">
                                                                    <div class="defa-option1-aedecp">
                                                                        <div class="custom-control custom-radio">
                                                                            <input :id="'marks' + key"
                                                                                v-model="infiltration.water"
                                                                                value="marks"
                                                                                class="custom-control-input"
                                                                                :name="'origin-option1' + key"
                                                                                type="radio">
                                                                            <label class="custom-control-label"
                                                                                :for="'marks' + key">Traces
                                                                                d'eau</label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="defa-option1-aedecp">
                                                                        <div class="custom-control custom-radio">
                                                                            <input :id="'visible' + key"
                                                                                v-model="infiltration.water"
                                                                                value="visible"
                                                                                class="custom-control-input"
                                                                                :name="'origin-option1' + key"
                                                                                type="radio">
                                                                            <label class="custom-control-label"
                                                                                :for="'visible' + key">Eau
                                                                                visible</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="default-form-field1-aedecp">
                                                        <div class="default-form-field1-in-aedecp">
                                                            <div
                                                                class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                                                <div
                                                                    class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp">
                                                                    L’origine
                                                                    est-elle (Facultatif) :
                                                                </div>
                                                                <div class="default-sub-form-row1-aedecp">
                                                                    <div
                                                                        class="defa-Ffield1-col1-aedecp defa-Ffield-Wauto-aedecp">
                                                                        <div class="defa-option-list-aedecp">
                                                                            <div class="defa-option1-aedecp">
                                                                                <div
                                                                                    class="custom-control custom-radio">
                                                                                    <input :id="'origin-visible-' + key"
                                                                                        v-model="infiltration.originVisibility"
                                                                                        :name="'origin-visibility-' + key"
                                                                                        :value="true"
                                                                                        class="custom-control-input"
                                                                                        type="radio">
                                                                                    <label
                                                                                        :for="'origin-visible-' + key"
                                                                                        class="custom-control-label">Apparente</label>
                                                                                </div>
                                                                            </div>
                                                                            <div class="defa-option1-aedecp">
                                                                                <div
                                                                                    class="custom-control custom-radio">
                                                                                    <input
                                                                                        :id="'origin-invisible-' + key"
                                                                                        v-model="infiltration.originVisibility"
                                                                                        :name="'origin-visibility-' + key"
                                                                                        :value="false"
                                                                                        class="custom-control-input"
                                                                                        type="radio">
                                                                                    <label
                                                                                        :for="'origin-invisible-' + key"
                                                                                        class="custom-control-label">Non
                                                                                        apparente</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="defa-Ffield1-col1-aedecp defa-Ffield-Wauto-aedecp">
                                                                        <div class="defa-option-list-aedecp">
                                                                            <div class="defa-option1-aedecp">
                                                                                <div
                                                                                    class="custom-control custom-radio">
                                                                                    <input
                                                                                        :id="'origin-accessible-' + key"
                                                                                        v-model="infiltration.originAccessible"
                                                                                        :name="'origin-accessibility' + key"
                                                                                        :value="true"
                                                                                        class="custom-control-input"
                                                                                        type="radio">
                                                                                    <label
                                                                                        :for="'origin-accessible-' + key"
                                                                                        class="custom-control-label">Accessible</label>
                                                                                </div>
                                                                            </div>
                                                                            <div class="defa-option1-aedecp">
                                                                                <div
                                                                                    class="custom-control custom-radio">
                                                                                    <input
                                                                                        :id="'origin-inaccessible-' + key"
                                                                                        v-model="infiltration.originAccessible"
                                                                                        :name="'origin-accessibility' + key"
                                                                                        :value="false"
                                                                                        class="custom-control-input"
                                                                                        type="radio">
                                                                                    <label
                                                                                        :for="'origin-inaccessible-' + key"
                                                                                        class="custom-control-label">Non
                                                                                        accessible</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="default-form-field1-aedecp">
                                                        <div class="default-form-field1-in-aedecp">
                                                            <div
                                                                class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                                                <div class="default-form-file-upload-tit-aedecp">Si vous
                                                                    disposez de photos de ce désordre, veuillez les
                                                                    joindre ci-dessous (2 photos max par désordre).
                                                                </div>
                                                                <DragAndDrop
                                                                    v-on:updateImages="e => infiltration.images = e.images"
                                                                    :max="2" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="contentAdd">
                                                <div class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp custom-add"
                                                    @click="addInfiltration">
                                                    <p class="btn-custom">+</p> Ajouter une infiltration
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="other" class="accordion">
                                    <div class="card Ndisorders-box1-main-aedecp">
                                        <div id="Ndisorders_heading3" class="card-header">
                                            <a aria-controls="Ndisorders_collapse3" aria-expanded="false"
                                                :class="['collapse', haveOtherFilled ? 'checked' : '']"
                                                data-target="#Ndisorders_collapse3" data-toggle="collapse" href="#">
                                                Autre désordre
                                            </a>
                                        </div>
                                        <div id="Ndisorders_collapse3" aria-labelledby="Ndisorders_heading3"
                                            class="collapse" data-parent="#other">
                                            <div v-for="(other, key) in renseignements_sinister.other" :key="key"
                                                class="card-body Ndisorders-info-box-aedecp">
                                                <div class="title">
                                                    <div
                                                        class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp">
                                                        Autre désordre {{ key + 1 }}
                                                    </div>
                                                    <div class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp custom-add"
                                                        @click="deleteDisorder(key)">
                                                        <p class="btn-custom">X</p>
                                                    </div>
                                                </div>
                                                <div class="Ndisord-info-box-in-aedecp">
                                                    <div class="default-form-field1-aedecp">
                                                        <div class="default-form-field1-in-aedecp">
                                                            <div
                                                                class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                                                <div
                                                                    class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp">
                                                                    Description du désordre et de sa localisation
                                                                    (Facultatif)
                                                                </div>
                                                                <div class="defa-form-field-Tbox-aedecp">
                                                                    <textarea v-model="other.description" cols="1"
                                                                        placeholder="" rows="10"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="default-form-field1-aedecp">
                                                        <div class="default-form-field1-in-aedecp">
                                                            <div
                                                                class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                                                                <div class="default-form-file-upload-tit-aedecp">Si vous
                                                                    disposez de photos de ce désordre, veuillez les
                                                                    joindre ci-dessous (2 photos max par désordre).
                                                                </div>
                                                                <DragAndDrop
                                                                    v-on:updateImages="e => other.images = e.images"
                                                                    :max="2" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="contentAdd">
                                                <div class="default-form-field1-tit-aedecp default-Ffield1-tit-gray-aedecp custom-add"
                                                    @click="addDisorder">
                                                    <p class="btn-custom">+</p> Ajouter un désordre
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="default-form-field1-aedecp">
                    <div class="default-form-field1-in-aedecp">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-12 defa-Ffield1-col1-aedecp">
                            <div class="default-form-file-upload-tit-aedecp">Si vous disposez d'un ou de plusieurs devis
                                détaillés correspondant aux désordres, veuillez les joindre ci-dessous (Facultatif)
                            </div>
                            <DragAndDrop v-on:updateImages="e => renseignements_sinister.devis = e.images" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="disordersCheck" class="danger-block-main-aedecp">
                <p>Il faut renseigner au moins un sinistre pour pouvoir poursuivre.</p>
            </div>
            <div class="warning-block-main-aedecp">
                <p>Pour nous permettre d’instruire plus rapidement votre sinistre, nous vous recommandons de joindre
                    quelques
                    photos des désordres et si possible un devis détaillé à votre déclaration.</p>
            </div>
            <div class="default-form-btn-bar-aedecp">
                <div class="default-form-btn-aedecp">
                    <a href="#" @click="previousStep" class="btn default-btn-aehp default-Bborder-btn-aehp">Etape
                        précédente</a>
                </div>
                <div class="default-form-btn-aedecp">
                    <a class="btn default-btn-aehp" href="#" v-on:click="nextStep">Continuer</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import DragAndDrop from '@/components/DragAndDrop/DragAndDrop.vue';
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import moment from 'moment';

export default {
    name: 'StepFour',
    components: {
        DragAndDrop
    },
    props: ['new', 'type'],
    data() {
        return {
            renseignements_sinister: {
                date: null,
                perfect_achievement: true,
                images: [],
                cracks: [
                    {
                        location: null,
                        gap: null,
                        engenders_infiltration: null,
                        material_fall_risk: null,
                        images: []
                    },
                ],
                infiltrations: [
                    {
                        location: null,
                        water: null,
                        originVisibility: null,
                        originAccessible: null
                    },
                ],
                other: [
                    {
                        description: null,
                    },
                ],
                garantees: [],
                devis: []
            },
            disordersCheck: false
        }
    },
    computed: {
        ...mapState({
            storeRenseignementsSinister: state => state.createSinistre.renseignements_sinister,
            storeConstructionInformation: state => state.createSinistre.construction_information,
            storeValidSteps: state => state.createSinistre.validSteps,
        }),
        showDemeure() {
            const disorderDate = moment(this.renseignements_sinister.date);
            const constructionDate = moment(this.storeConstructionInformation.receipt_work_date);
            const diffInYears = disorderDate.diff(constructionDate, 'years', true);
            return diffInYears <= 1;
        },
        haveCrackFilled() {
            return this.renseignements_sinister.cracks.some(crack => crack.location || crack.gap || crack.engenders_infiltration || crack.material_fall_risk || crack.images.length > 0);
        },
        haveInfiltrationFilled() {
            return this.renseignements_sinister.infiltrations.some(infiltration => infiltration.location || infiltration.water || infiltration.originVisibility || infiltration.originAccessible || infiltration.images.length > 0);
        },
        haveOtherFilled() {
            return this.renseignements_sinister.other.some(other => other.description || other.images.length > 0);
        }
    },
    beforeMount() {
        this.renseignements_sinister = { ...this.storeRenseignementsSinister }
    },
    mounted() {
        $('.datepicker_hp3').datepicker({
            uiLibrary: 'bootstrap4',
            iconsLibrary: 'fontawesome',
            format: "dd/mm/yyyy",
            language: "fr"
        }).on('changeDate', (e) => this.renseignements_sinister.date = e.date);
    },
    unmounted() {
        $('.datepicker_hp3').datepicker('destroy');
    },
    methods: {
        ...mapActions('createSinistre', ['addSinisterDetails']),
        updateImages(props) {
            this.renseignements_sinister.images = props.images;
        },
        previousStep() {
            this.addSinisterDetails(this.renseignements_sinister);
            if (this.isFormValid()) {
                if (!this.storeValidSteps.includes(4)) {
                    this.storeValidSteps.push(4);
                }
            } else {
                if (this.storeValidSteps.includes(4)) {
                    this.storeValidSteps.splice(this.storeValidSteps.indexOf(4), 1);
                }
            }
            this.$emit("click", { action: "StepThree" });
        },
        nextStep() {
            console.log(this);
            if (this.type === 'assured') {
                let numberInput = 3;
                let numberGoodInputFour = 0;
                $(".stepFour input.cal-size").each(function () {
                    if (!$(this).val()) {
                        $(this).addClass('errorInput');
                    } else {
                        numberGoodInputFour++
                        $(this).removeClass('errorInput');
                    }
                });

                if (this.showDemeure && this.renseignements_sinister.perfect_achievement && this.renseignements_sinister.images.length === 0) {
                    $('.default-form-file-upload-tit-aedecp').addClass('errorColor');
                } else {
                    $('.default-form-file-upload-tit-aedecp').removeClass('errorColor');
                    if (!this.showDemeure) {
                        this.renseignements_sinister.perfect_achievement = false;
                        this.renseignements_sinister.images = [];
                    }
                    numberGoodInputFour++;
                }

                if (this.renseignements_sinister.cracks[0].location || this.renseignements_sinister.infiltrations[0].location || this.renseignements_sinister.other[0].description) {
                    numberGoodInputFour++;
                    this.disordersCheck = false;
                } else {
                    this.disordersCheck = true;
                }

                if (numberInput === numberGoodInputFour) {
                    this.addSinisterDetails(this.renseignements_sinister);
                    if (!this.storeValidSteps.includes(4)) {
                        this.storeValidSteps.push(4);
                    }
                    this.new ? this.$emit('click', { action: 'End' }) : this.$emit('click', { action: 'StepFive' });
                } else {
                    const firstErrorInput = document.querySelector('.errorInput');
                    const firstErrorColor = document.querySelector('.errorColor');
                    if (firstErrorInput) {
                        firstErrorInput.scrollIntoView({ behavior: 'smooth' });
                    } else if (firstErrorColor) {
                        firstErrorColor.scrollIntoView({ behavior: 'smooth' });
                    }
                }
                console.log(numberInput)
                console.log('numberGoodInputFour', numberGoodInputFour)
            } else {
                this.addSinisterDetails(this.renseignements_sinister);
                this.new ? this.$emit('click', { action: 'End' }) : this.$emit('click', { action: 'StepFive' });
            }
        },
        isFormValid() {
            let numberInput = 3;
            let numberGoodInputFour = 0;

            $(".stepFour input.cal-size").each(function () {
                if (!$(this).val()) {
                    return false
                } else {
                    numberGoodInputFour++
                }
            });

            if (this.showDemeure && this.renseignements_sinister.perfect_achievement && this.renseignements_sinister.images.length === 0) {
                return false;
            } else {
                numberGoodInputFour++;
            }

            if (this.renseignements_sinister.cracks[0].location || this.renseignements_sinister.infiltrations[0].location || this.renseignements_sinister.other[0].description) {
                numberGoodInputFour++;
            } else {
                return false;
            }

            return numberInput === numberGoodInputFour;
        },

        addGarantees(e) {
            const element = this.renseignements_sinister.garantees.includes(e.target.value);
            // element ?  this.renseignements_sinister.garantees.push(e.target.value) :  this.renseignements_sinister.garantees.filter((c) => { return c !== e.target.value });
            if (!element) {
                console.log('push')
                this.renseignements_sinister.garantees.push(e.target.value);
            } else {
                _.remove(this.renseignements_sinister.garantees, function (n) {
                    return n == e.target.value
                })
            }
            console.log(this.renseignements_sinister.garantees);
        },
        addCrack() {
            this.renseignements_sinister.cracks.push({
                location: null,
                gap: null,
                engenders_infiltration: null,
                material_fall_risk: null,
                images: []
            })
        },
        addInfiltration() {
            this.renseignements_sinister.infiltrations.push({
                location: null,
                water: null,
                originVisibility: null,
                originAccessible: null,
                images: []
            })
        },
        addDisorder() {
            this.renseignements_sinister.other.push({
                description: null,
                images: []
            })
        },
        deleteCrack(key) {
            this.renseignements_sinister.cracks.splice(key, 1)
        },
        deleteInfiltration(key) {
            this.renseignements_sinister.infiltrations.splice(key, 1)
        },
        deleteDisorder(key) {
            this.renseignements_sinister.other.splice(key, 1)
        },
        remove(e) {
            $(e).removeClass('errorInput');
        },
        formatDate(date) {
            if (!date || !moment(date).isValid()) {
                return '';
            }
            return moment(date).format('DD/MM/YYYY');
        },
        onDateBlur(e, field) {
            const date = moment(e.target.value, 'DD/MM/YYYY');
            if (!date.isValid()) {
                this.renseignements_sinister[field] = null;
            }
            else {
                this.renseignements_sinister[field] = date.toDate();
            }
        }
    }
}
</script>
<style scoped>
.contentAdd {
    background: #FAFBFF;
    padding: 0 15px 15px;
    }
    
    .btn-custom {
        color: white;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #00B8E4;
        margin-right: 10px;
    }
    
    .custom-add:hover .btn-custom {
        background: white;
        color: #00B8E4;
        border: solid 1px #00B8E4
    }
    
    .custom-add {
        cursor: pointer;
        display: flex;
    }
    
    .title {
        display: flex;
        justify-content: space-between;
    }
    
    .errorInput {
        border: solid 2px #f03737;
    }
    
    .errorColor {
        color: #f03737
    }
    
    .danger-block-main-aedecp {
        border: solid 1px #f03737;
        background: #FBF2F2;
        margin: 0px 0px 16px;
        padding: 15px 48px 15px;
        text-align: center;
    }
    
    .danger-block-main-aedecp p {
        font-size: 13px;
        line-height: 19px;
        color: #f03737;
        font-weight: 600;
        margin: 0px;
        padding: 0px;
}
</style>
